import { render, staticRenderFns } from "./StockVideoBox.vue?vue&type=template&id=7246bf5c&scoped=true"
import script from "./StockVideoBox.vue?vue&type=script&lang=js"
export * from "./StockVideoBox.vue?vue&type=script&lang=js"
import style0 from "./StockVideoBox.vue?vue&type=style&index=0&id=7246bf5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246bf5c",
  null
  
)

export default component.exports